import React from 'react';
import './TimelineExchange.scss';
import { connect } from 'react-redux';
import { formatDate } from '../../../utils/helper';

function getStep(index, step, position, negative) {
  if (position && position?.indexOf('img-banner') > -1) {
    return '';
  } else if (position && index <= Number(step) && negative) {
    return 'negative';
  } else if (position && index < Number(step)) {
    return 'active';
  } else if (position && index === Number(step)) {
    return 'current';
  }
  return '';
}
function getDateMonth(date) {
  return formatDate(new Date(date).getTime(), 'EEE, D MMM');
}
function getMonthDateYear(date) {
  return formatDate(new Date(date).getTime(), 'MMM D,', 'year');
}
// pass horizontal if you need horizontal timeline else pass vertical
// If you want images in vertical timeline pass img-banner
// pass the index to current the current progress
// In horizontal timeline there are active and current class
function TimelineExchange(props) {
  const {
    step,
    position,
    negativeStatuses = [],
    showSubStatus = false,
    className,
    dataLocale: { IMG },
    desktop,
    isDesktopReturn,
  } = props;
  let { progressFields } = props;
  progressFields = Object.assign({}, progressFields);
  return (
    <div className={`progress-container bg-color_white pd-l10 pd-r10 pd-t10 ${className || ''}`}>
      {progressFields.title && (
        <div className={`fsp14 lh-16 text-color_grey_black mr-b10 ${desktop ? 'fw600' : 'fw500'}`}>
          {progressFields.title}
        </div>
      )}
      <div
        className={`display-flex ${
          desktop ? 'flex-column margin-t15 desktop-left' : ''
        } mr-0 pd-0 pd-t4 pd-b4 flex-${position} ${isDesktopReturn ? 'padding-l50' : ''}`}
        data-testid="progressContainer"
      >
        {progressFields.data &&
          progressFields.data.map((item, index) => {
            const {
              label,
              status,
              statusLabel,
              showBar,
              img,
              buttonText,
              buttonHandler,
              subStatusLabel,
              subStatusLink,
              pickupTrackingDetails,
              date,
            } = item;
            const { courier, trackingId, trackingLink } = pickupTrackingDetails || {};
            if (!statusLabel && !label) return null;
            let displaySubStatusLabel = subStatusLabel + '';
            const displayDate = getMonthDateYear(date);
            if (subStatusLabel && subStatusLabel?.indexOf('{') > -1) {
              displaySubStatusLabel = displaySubStatusLabel.replace(/\{.*?[^\}]\}/g, displayDate);
            }
            const negative = status ? negativeStatuses?.indexOf(status) > -1 : false;
            return (
              <div
                key={index}
                className={`pos-rel text-center progress-item ${getStep(
                  index,
                  step,
                  position,
                  negative
                )}`}
              >
                <React.Fragment>
                  {showBar === 'yes' && <span className="progressbar">&nbsp;</span>}
                </React.Fragment>
                {position && !isDesktopReturn && position?.indexOf('horizontal') > -1 && (
                  <span className="progress-circle inline-block pos-rel mr-b5">&nbsp;</span>
                )}
                {img && !buttonText && (
                  <div className="img-circle display-flex justify-content-center align-items-center">
                    <img alt={IMG} src={img} />
                  </div>
                )}
                {img && buttonText && (
                  <div className="flex-direction-column display-flex">
                    <div className="display-flex">
                      <div className="img-circle display-flex justify-content-center align-items-center">
                        <img alt={IMG} src={img} />
                      </div>
                      <div className="progressText fsp13 lh-16 text-color_dull_black">{label}</div>
                      {props[buttonHandler] && desktop && (
                        <span
                          className="text-color-primary cursor-pointer lh-14 fw700 text-uppercase"
                          onClick={props[buttonHandler]}
                        >
                          {buttonText}
                        </span>
                      )}
                    </div>
                    {props[buttonHandler] && !desktop && (
                      <button
                        aria-label="timeline-btn"
                        className="timeline-btn text-topaz fsp12 lh-14 fw700 bora-4 text-uppercase mr-t8 mr-b8"
                        onClick={props[buttonHandler]}
                      >
                        {buttonText}
                      </button>
                    )}
                  </div>
                )}
                {!buttonText && (
                  <React.Fragment>
                    <div
                      className={`progressText fsp14 lh-16 ${
                        isDesktopReturn ? 'desktop-return' : ''
                      }`}
                    >
                      {label || statusLabel}
                      {subStatusLink && subStatusLabel && (
                        <div style={{ marginTop: '5px' }}>
                          <a className="fw300 block mr-t5" href={subStatusLink}>
                            {displaySubStatusLabel}
                          </a>
                        </div>
                      )}
                      {showSubStatus && subStatusLabel && !subStatusLink && (
                        <span className="fw300 block mr-t5">{displaySubStatusLabel}</span>
                      )}
                      {pickupTrackingDetails && (
                        <React.Fragment>
                          {courier && <span className="fw300 block mr-t5">Courier: {courier}</span>}
                          {trackingId && (
                            <span className="fw300 block mr-t5">Tracking ID: {trackingId}</span>
                          )}
                          {trackingLink && (
                            <a className="fw300 block mr-t5" href={trackingLink}>
                              Track Your Pickup
                            </a>
                          )}
                        </React.Fragment>
                      )}
                    </div>
                  </React.Fragment>
                )}
                {date && position === 'direction-column' && (
                  <div
                    className="nowrap border-bottom pd-b12 fsp12 lh-14 text-color_grey_black"
                    data-testid={`statusDate${index}`}
                  >
                    {getDateMonth(date)}
                  </div>
                )}
                {date &&
                  isDesktopReturn &&
                  position === 'direction-row horizontal exchange-timeline' && (
                    <div
                      className="nowrap date pd-b12 fs10 lh-14 text-color-grey"
                      data-testid={`statusDate${index}`}
                    >
                      {getDateMonth(date)}
                    </div>
                  )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    dataLocale: state.locale,
  };
};

export default connect(mapStateToProps, null)(TimelineExchange);
